import { connect } from 'react-redux';
import {
  sessionViewSelectors,
  setSessionActiveTab,
} from '../../../../../../redux/views/session-view/session/slice';
import { RootState } from '../../../../../../redux/store';
import { sessionApi } from '../../../../../../redux/views/session-view/session/api/api';
import { publicSessionApi } from '../../../../../../redux/views/session-view/session/api/publicApi';
import { ActionsBarLeft } from '.';

export type ActionBarLeftContainerOwnProps = {
  accessKey?: string;
  versionUid: string;
  sessionUid: string;
};

const mapStateToProps = (
  state: RootState,
  { accessKey, versionUid, sessionUid }: ActionBarLeftContainerOwnProps,
) => {
  let isLaunchPanelEnabled = false;
  let data;

  if (accessKey) {
    data = publicSessionApi.endpoints.getPublicSession.select({
      accessKey,
      sessionUid,
      versionUid,
    })(state);
  } else {
    data = sessionApi.endpoints.getSession.select({
      sessionUid,
      versionUid,
    })(state);
  }

  isLaunchPanelEnabled = data.data?._links?.launchPanelData !== undefined;

  return {
    isLaunchPanelEnabled,
    sessionActiveTab: sessionViewSelectors.getSessionActiveTab(state),
  };
};

const mapDispatchToProps = {
  setSessionActiveTab,
};

export type ActionsBarLeftProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const ActionsBarLeftContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionsBarLeft);
